export const APPLICATION_REQUEST = 'APPLICATION_REQUEST'
export const APPLICATION_RESET = 'APPLICATION_RESET'
export const APPLICATION_SUCCESS = 'APPLICATION_SUCCESS'
export const APPLICATION_ERROR = 'APPLICATION_ERROR'
